import React from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useSelector, useDispatch } from 'react-redux';
import { notification } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

import Messages from 'i18n/messages/home';
import messagesProduct from 'i18n/messages/product';

import { RibbonButton, dialogFunction } from 'common/components';

import { deleteProductFromApl } from 'services/apl';
import {
  makeSelectAplProductListSelect,
  makeSelectAplDetail,
} from 'pages/product-apl-detail/controllers/selectors';
import { toggleReloadGrid } from 'pages/product-apl-detail/controllers/actions';

import { sleep } from 'utils/delay';
import { useCheckDisabledMasterAplBtn } from '../../sections/product-apl/hooks';
import { MASTER_APL_NAME } from '../../sections/product-apl/constants';

import { getAplDetail } from 'pages/product-apl-detail/controllers/actions';

const DeleteProductApl = () => {
  const intl = useIntl();

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const selectedItems = useSelector(makeSelectAplProductListSelect());
  const aplDetail = useSelector(makeSelectAplDetail());

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn(aplDetail);

  const checkDisabledDeleteProductAplBtn = () => {
    if (selectedItems?.length !== 1) return true;

    if (aplDetail?.aplName === MASTER_APL_NAME) return isDisabledMasterAplBtn;
    return !aplDetail?.isOwner;
  };

  const isDisabledBtn = checkDisabledDeleteProductAplBtn();

  const handleSubmit = async () => {
    const params = {
      aplProductId: selectedItems?.[0],
    };

    try {
      const response = await deleteProductFromApl(params);

      if (response?.isSuccess) {
        notification.success({
          message: intl.formatMessage(messagesProduct.deleteProductAplSuccess),
        });

        queryClient.invalidateQueries({
          queryKey: ['apl'],
        });

        await sleep(1000);
        dispatch(toggleReloadGrid(true));
        dispatch(getAplDetail({ aplId: aplDetail?.aplId }));
      } else {
        notification.error({
          message: response?.message,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        dispatch(toggleReloadGrid(false));
      }, 200);
    }
  };

  const handleDeleteProductApl = () => {
    dialogFunction({
      type: 'warn',
      content: intl.formatMessage(messagesProduct.confirmDeleteProductToApl),
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: handleSubmit,
    });
  };

  return (
    <RibbonButton
      size='small'
      icon={<CloseCircleOutlined style={{ height: 26 }} />}
      label={Messages.deleteProductApl}
      onClick={handleDeleteProductApl}
      disabled={isDisabledBtn}
      className='button-item-dropdown'
    />
  );
};

export default DeleteProductApl;
